import { useMemo } from "react";
import { Button, Col, Form, Modal, Row } from "react-bootstrap";
import * as Yup from 'yup';
import { FormikProvider, useFormik } from "formik";
import { ACCOUNT_DELETION_TIMEOUT_DAYS } from "common/constants";
import { stringRequired } from "helpers/validationHelper";


export default function AccountDeleteConfirmationPopup({ showPopup, closePopup, userDetail, handleSubmit }) {
	const validationSchema = useMemo(() => {
		if(!userDetail) {
			return Yup.object();
		}

		return Yup.object().shape({
			reason: stringRequired("Reason", { min: 15, max: 250 }),
			user_name: Yup.string()
        .lowercase()
				.required(`To confirm, please enter your account email.`)
				.oneOf([userDetail?.email?.toLowerCase()], "The entered email does not match. Please enter the correct email to proceed."),
		});
	}, [userDetail]);
	
	const formik = useFormik({
		initialValues: {
			reason: "",
			user_name: ""
		},
		validationSchema: validationSchema,
		onSubmit: handleSubmit,
		enableReinitialize: true,
	})

	const handleClose = () => {
		formik.resetForm();
		closePopup();
	}

	return (
		<>
			<Modal
				show={showPopup}
				onHide={handleClose}
				backdrop="static"
				keyboard={false}
				centered
				size="md"
			>
				<Modal.Header closeButton>
					<Modal.Title>Delete Account</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FormikProvider
						value={formik}
					>
						<Form onSubmit={formik.handleSubmit} autoComplete="off">
							<Row>
								<Col lg="12" className="mb-2">
									<p className="m-0 text-small">
										<span className="fw-bold">Note:</span>{" "}
                    Your account will be deleted from the platform immediately.
										However, you can restore it within <span className="fw-bold">{ACCOUNT_DELETION_TIMEOUT_DAYS} days</span> by contacting support before it is permanently removed.
									</p>
								</Col>
								<Col lg="12" className="my-2">
									<label htmlFor="" className="form-label m-0 fw-sbold">
                    Please share your reason for account deletion *
									</label>
									<textarea
										className={`form-control ${formik.errors.reason && "is-invalid"}`}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										name="reason"
										value={formik.values.reason}
                    rows={3}
									/>
									{formik.errors.reason && formik.touched.reason && (
										<p className="invalid-feedback">{formik.errors.reason}</p>
									)}
								</Col>
								<Col lg="12" className="my-2">
									<label htmlFor="" className="form-label m-0 fw-sbold">
										Confirm by entering your email address *
									</label>
									<input
										type="text"
										className={`form-control ${formik.errors.user_name && "is-invalid"}`}
										onChange={formik.handleChange}
										onBlur={formik.handleBlur}
										name="user_name"
										value={formik.values.user_name}
									/>
									{formik.errors.user_name && formik.touched.user_name && (
										<p className="invalid-feedback">{formik.errors.user_name}</p>
									)}
								</Col>
								<Col lg="12" className="mt-3">
									<Modal.Footer>
										<Button
                      className="d-flex align-items-center justify-conten-center commonBtn btnSm btn-danger"
											onClick={handleClose}
										>
											Close
										</Button>
										<Button
											type="submit"
                      variant="danger"
                      className="d-flex align-items-center justify-conten-center btnSm"
											disabled={formik.isSubmitting || !formik.isValid}
										>
											{formik.isSubmitting ? 'Please Wait...' : 'Confirm'}
										</Button>
									</Modal.Footer>
								</Col>
							</Row>
						</Form>
					</FormikProvider>
				</Modal.Body>
				</Modal>
		</>
	);
}